module.exports = __webpack_public_path__ + "img/AstroFrenz163.9c756b5f.jpg";